


export class ViewParametroSistemaEriproc {
  "Nome";
  "Inclusao";
  "Valor";
  "Descricao";
  "Usuario";
  "DataAlteracao";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewParametroSistemaEriproc`.
   */
  static getModelName() {
    return "ViewParametroSistemaEriproc";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewParametroSistemaEriproc for dynamic purposes.
  **/
  static factory(data) {
    return new ViewParametroSistemaEriproc(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ViewParametroSistemaEriproc',
      plural: 'ViewParametroSistemaEriprocs',
      path: 'ViewParametroSistemaEriprocs',
      properties: {
        "Nome": {
          name: 'Nome',
          type: 'string'
        },
        "Inclusao": {
          name: 'Inclusao',
          type: 'Date'
        },
        "Valor": {
          name: 'Valor',
          type: 'string'
        },
        "Descricao": {
          name: 'Descricao',
          type: 'string'
        },
        "Usuario": {
          name: 'Usuario',
          type: 'string'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ViewParametroSistemaEriproc.js